export function filterUniqueObjectsArrayByIdProp<
  TObject extends { id: number | string },
  TArray extends TObject[] | undefined,
>(arr: TArray): TArray {
  if (!arr) return arr;
  const map = new Map<number | string, TObject>();
  arr.forEach((item) => map.set(item.id, item));
  return Array.from(map.values()) as TArray;
}
